import type { SyntheticEvent } from "react";
import { selectCurrencies } from "features/general/selectors";
import StatefulSelector from "ui/widgets/StatefulSelector";
import type { CsvValue, SetupValueProps } from "../types";
import { FormField } from "../../types";
import { withUnique } from "./common";

const CsvCurrency = ({ values, onChange }: SetupValueProps<CsvValue>) => {
    const onAutocompleteChange = (_: SyntheticEvent, currencies: Array<string>) =>
        onChange!(currencies);

    return (
        <StatefulSelector
            multiple
            fullWidth
            disableClearable
            layout={null}
            sx={{
                gridColumn: 'span 2'
            }}
            selectOptions={selectCurrencies}
            value={values[FormField.SetupValue].value}
            TextFieldProps={{
                label: 'Currency'
            }}
            onChange={onAutocompleteChange}
        />
    );
};

export default withUnique(CsvCurrency);
